<!-- Top navigation between Report and Analysis -->
<div *ngIf="false"
  class="report-analysis-tabs"
  style="
    margin: 1rem 10px 15px 10px;
    display: flex;
    gap: 24px;
    border-bottom: 1px solid #ddd;
  "
>
  <span
    class="tab-link"
    [class.active]="activeSection === 'analysis'"
    (click)="switchSection('analysis')"
    style="
      cursor: pointer;
      font-weight: 600;
      padding: 8px 16px;
      border-radius: 6px 6px 0 0;
      transition: 0.2s;
    "
  >
    Analysis
  </span>
  <span
    class="tab-link"
    [class.active]="activeSection === 'report'"
    (click)="switchSection('report')"
    style="
      cursor: pointer;
      font-weight: 600;
      padding: 8px 16px;
      border-radius: 6px 6px 0 0;
      transition: 0.2s;
    "
  >
    Report
  </span>
</div>

<div *ngIf="false" class="section-content">
  <!-- REPORT SECTION -->
  <div *ngIf="activeSection === 'report'">
   
        <div
          class="report-body"
          [style.background-color]="backgroundColorScreen"
        >
         <div class="actions-tabs" style="margin-left: 1%;">
    <div
      class="tab-item"
      [class.active]="activeComponent === 'history'"
      (click)="showHistory()">
      <i class="fas fa-tasks"></i>
      <span>Generated Report</span>
    </div>

    <div
      class="tab-item"
      [class.active]="activeComponent === 'upcoming'"
      (click)="showUpcoming()">
      <i class="fas fa-clock"></i>
      <span>Upcoming Report</span>
    </div>

    <div
      class="tab-item"
      [class.active]="activeComponent === 'reportTemplate'"
      (click)="showReportTemplate()">
      <!-- <i class="fas fa-calendar-alt"></i> -->
       <i class="fas fa-file-alt"></i>
      <span>Report Template</span>
    </div>
  </div>

          <!-- Dynamic component display -->
          <div class="content">
            <ng-container *ngIf="activeComponent === 'history'">
              <app-report-instance-history [screenPathFromParent]="'reportInstanceDetails'"></app-report-instance-history>
            </ng-container>

            <ng-container *ngIf="activeComponent === 'upcoming'">
              <app-report-instance-upcoming></app-report-instance-upcoming>
            </ng-container>
             <ng-container *ngIf="activeComponent === 'reportTemplate'">
               <app-report-template></app-report-template>
            </ng-container>
          </div>
        </div>
  </div>

  <!-- ANALYSIS SECTION -->
  <div *ngIf="activeSection === 'analysis'">
    <!-- <h3 style="margin-left: 10px; margin-right: 10px">Analysis</h3> -->

    <!-- Dropdown -->
    <div
      style="
        display: flex;
        flex-wrap: wrap;
        gap: 12px;
        align-items: center;
        margin-top: 2rem;
        margin-left: 10px;
        margin-right: 10px;
      "
    >
      <mat-form-field appearance="outline" class="w-50 m-0">
        <mat-label>Select Dataset</mat-label>
        <mat-select
          [(ngModel)]="selectedDataset"
          (selectionChange)="onDatasetSelect()"
        >
          <mat-option value="">-- Select Dataset --</mat-option>
          <mat-option *ngFor="let ds of datasets" [value]="ds">
            {{ ds.datasetname }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <div style="margin-bottom :1rem;">
        <!-- <button
          class="popup gridColour btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize"
          [style.background-color]="backgroundColorButton"
          style="margin: 0 0 1.2rem; padding: 0.5rem"
          (click)="openAnalysis(selectedDataset)"
        >
          Analysis
        </button> -->
        <app-common-button
 
          label="Analysis"
 
          title="Analysis "
              
          [buttonId]="1111"
 
          width="110px"
          [critical]="false"
          (clicked)="openAnalysis(selectedDataset)"
 
           style="margin-left: 6px;margin-right:6px; padding: 0.5rem;"
 
          >
 
          </app-common-button>

      </div>
    </div>
  </div>
  <!-- Bottom buttons -->
  <div class="actions-btn">
    <!-- <button mat-stroked-button type="button" class="cancel-btn" (click)="goBack()">Cancel</button> -->

     <app-common-button
 
          label="Back"
 
          title="Back "
              
          [buttonId]="1111"
          variant="cancel"
 
          width="110px"
          [critical]="false"
          (clicked)="goBack()"
 
           style="margin-left: 6px;margin-right:6px;"
 
          >
 
          </app-common-button>

    <!-- <button
      mat-raised-button
      [style.background-color]="backgroundColorButton"
      (click)="goToAssessment()"
    >
      Next
    </button> -->
    		<app-common-button
 
          label="Next"
 
          title="Next "
 
        
 
          [buttonId]="1111"
 
          width="110px"
          [critical]="false"
          (clicked)="goToAssessment()"
 
           style="margin-left: 6px;margin-right:6px;"
 
          >
 
          </app-common-button>
  </div>
</div>
<div class="excel-card">

  <div class="excel-header">
      <!-- <h3>Report Preview</h3>
      <p>{{ selectedSheet }}</p>  Report Preview-->
      <div class="preview-title">
  <h3>{{selectedActivity.activityName}}</h3>

  <ng-container>
    <span class="report-name">
      {{ reportTitleRow[0] }}
    </span>

    <span class="report-date" *ngIf="reportInfoRow?.length">
      {{ reportInfoRow[0] }} {{ reportInfoRow[1] }}
    </span>
  </ng-container>

  <!-- <p *ngIf="selectedSheet !== 'Report'">{{ selectedSheet }}</p> -->
</div>
    <span class="example-spacer"></span>
     <app-common-button
 
          label="Back"
 
          title="Back "
              
          [buttonId]="1111"
          variant="cancel"
           height="25px"
          width="110px"
          [critical]="false"
          (clicked)="goBack()"
 
           style="margin-left: 6px;margin-right:6px;"
 
          >
 
          </app-common-button>
            <!-- <app-common-button
            title="Download"
          icon="fas fa-download"
          [buttonId]="1111"
          [variant]="'cancel'"
          width="100%"
          padding="0rem 1rem"
          fontSize=".85rem"
          height="25px"
          (clicked)="onDownloadhistory()"
          style="margin-right:1%"
          >
      </app-common-button> -->
     <app-common-button
          title="Download"
          icon="fas fa-download"
          [buttonId]="1111"
          [variant]="'cancel'"
          height="25px"
          width="100%"
          padding="0rem 1rem"
          [critical]="true"
          (clicked)="downloadSheet()"
           style="margin-left: 6px;margin-right:6px;"
          >
          </app-common-button>
          	<app-common-button
 
            *ngIf="showNextButton"
          label="Next"
 
          title="Next "
 
        
 
          [buttonId]="1111"
 
          width="110px"
           height="25px"
          [critical]="false"
          (clicked)="goToAssessment()"
 
           style="margin-left: 6px;margin-right:6px;"
 
          >
 
          </app-common-button>
  </div>
  <div class="sheet-tabs">
    <button *ngFor="let sheet of sheetNames"
            (click)="selectSheet(sheet)"
            [class.active]="sheet === selectedSheet">
      {{ sheet }}
    </button>
     
    
  </div>

  <div class="excel-toolbar">
      <input
    type="text"
    class="excel-search"
    placeholder="Search..."
    [(ngModel)]="searchText"
    (input)="applySearch()" />

     <div class="page-size">
  <span>Rows</span>

  <select [(ngModel)]="pageSizeValue" (change)="onPageSizeChange()">
    <option [ngValue]="100">100</option>
    <option [ngValue]="200">200</option>
    <option [ngValue]="500">500</option>
    <option [ngValue]="'ALL'">ALL</option>
  </select>

     <span>
     Showing {{ rowData.length }} of {{ filteredRowData.length }} rows
    </span>

</div>
 
    <div class="pagination-controls">
      <button (click)="prevPage()" [disabled]="currentPage === 1">
        Previous
      </button>
 <div class="page-jump">
      <span>Page</span>

      <input
        type="number"
        min="1"
        [max]="totalPages"
        [(ngModel)]="pageInput"
        (keyup.enter)="goToPage()"
        class="page-input">

      <span>of {{ totalPages }}</span>

      <!-- <button (click)="goToPage()">Go</button> -->
    </div>
      <!-- <span>Page {{ currentPage }} / {{ totalPages }}</span> -->

      <button (click)="nextPage()" [disabled]="currentPage === totalPages">
        Next
      </button>
    </div>
  </div>

  <div class="excel-container">
    <!-- <table class="excel-table">
       <tbody>
    <tr *ngFor="let row of rowData; let rowIndex = index">
      <th class="row-number">
        {{ ((currentPage - 1) * pageSize) + rowIndex + 1 }}
      </th>

      <td *ngFor="let cell of row">
        {{ cell }}
      </td>
    </tr>
  </tbody>
    </table> -->
    <table class="excel-table">

  <thead *ngIf="selectedSheet === 'Report'">
    <tr>
      <th class="corner-cell">#</th>
      <th *ngFor="let header of reportHeaderRow" class="report-fixed-header">
        {{ header }}
      </th>
    </tr>
  </thead>

  <tbody>
    <tr *ngFor="let row of rowData; let rowIndex = index">
      <th class="row-number">
        {{ ((currentPage - 1) * pageSize) + rowIndex + 1 }}
      </th>

      <td *ngFor="let cell of row">
        {{ cell }}
      </td>
    </tr>
  </tbody>

</table>
  </div>

</div>